module.exports = __webpack_public_path__ + "img/new-form-img.090d5ed1.jpg";